// DEVIATION from the plan: imports ChessRestClient and getLocalStorage by
// relative path rather than the '@' alias. jest.config.js has no
// moduleNameMapper for '@' (only webpack.config.js defines that alias, for
// the app bundle), and jest.config.js is a pre-existing file this task may
// not touch. A runtime '@/...' import here would fail under jest with
// "Cannot find module '@/Api/ChessRestClient'". Relative paths resolve
// identically under both webpack and jest, so this changes nothing about the
// app's runtime behavior.
import ChessRestClient from '../../Api/ChessRestClient';
import {getLocalStorage} from '../../Utils/CommonUtils';
import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {GeneratedCourse} from './types';

export async function fetchGeneratedCourse(
  bookUuid: string,
): Promise<GeneratedCourse> {
  const token = await getLocalStorage('access_token');
  const response = await ChessRestClient.get(
    `/video_learning/course/${bookUuid}/`,
    {headers: {Authorization: `Bearer ${token}`}},
  );
  return response.data as GeneratedCourse;
}

/**
 * The video URLs in this payload are presigned and expire in 48h, so the course
 * is refetched rather than persisted. `staleTime` is deliberately well under
 * that window.
 */
export function useGeneratedCourse(
  bookUuid?: string,
): UseQueryResult<GeneratedCourse, Error> {
  return useQuery<GeneratedCourse, Error>(
    ['generated-course', bookUuid],
    () => fetchGeneratedCourse(bookUuid as string),
    {enabled: !!bookUuid, staleTime: 30 * 60 * 1000},
  );
}
